import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { IndependentIraUser, IndependentIraUserRequest } from 'services/requests';
import { ApiError } from 'services/api.errors';
import { useNavigate } from 'hooks/routes';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useAddIndependentIraUser = () => {
  const queryClient = useQueryClient();
  const mutate = async (payload: IndependentIraUserRequest) => {
    const { data } = await api.addIndependentIraUser(payload);
    return data;
  };

  const mutationKey = MutationKeys.addIndependentIraUser;
  const { toIndependentIraInfo } = useNavigate();

  return useMutation<IndependentIraUser, AxiosError<ApiError>, IndependentIraUserRequest>(
    mutationKey,
    mutate,
    {
      onSuccess(data) {
        queryClient.setQueryData(
          [QueryKeys.independentIraUser, data.id.toString()],
          data,
        );
        queryClient.invalidateQueries(QueryKeys.independentIraUsers);

        if (Boolean(data.id)) {
          toIndependentIraInfo(data.id.toString(), { replace: true });
        }
      },
    },
  );
};
